/* eslint-disable react/jsx-no-bind */
import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { MultipleAccountSelector } from '@bingads-webui-campaign-react/multiple-account-selector';
import { Button } from '@bingads-webui-react/primitive';
import { withPopover } from '@bingads-webui/filter-commons';

const MultipleAccountSelectorPopover = withPopover(MultipleAccountSelector);

// popover state transition
// on page loading:
//    this.state.masVisible: true
//    this.initialized: undefined
//    "hidden" is appended to popover class, popover is rendered and hidden (display:none)
// user clicks account selector button for the first time
//    this.state.masVisible remains true
//    this.initialized becomes true
//    "hidden" is removed and popover immediately becomes visible because "display:none" is removed
// user clicks Apply/Cancel/All Accounts
//    this.state.masVisible turns false, popover is dismissed and account selector is **destructed**
// user clicks outside account selector
//    nothing happens, withPopover.props.onClose is no-op
// user clicks All Accounts
//    this.state.masVisible turns true, popover is rendered with a **new** account selector
//    cc is called again to get customer tree

export class AccountSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      masVisible: true,
    };
  }

  onMasSelectedChange = (selected) => {
    this.toggleMas();

    // inform dimensions page that selected accounts are updated
    this.props.updateSelected(selected);
  }

  onAccountSelectorButtonClick = () => {
    if (!this.initialized) {
      this.initialized = true;
      document.getElementById('account-selector-popover').classList.remove('hidden');
    } else {
      this.toggleMas();
    }
  }

  toggleMas() {
    this.setState({
      masVisible: !this.state.masVisible,
    });
  }

  render() {
    return (
      <MultipleAccountSelectorPopover
        show={this.state.masVisible}
        id="account-selector-popover"
        onSelectedChange={this.onMasSelectedChange}
        getDefaultSelected={this.props.getSelectedScope}
        onDismiss={this.toggleMas.bind(this)}
        serverContext={this.props.serverContext}
        container={this}
        popoverClassName={`${this.props.classes.accountSelectorPopover} ${this.state.masVisible && !this.initialized && 'hidden'}`}
        onClose={_.noop}
      >
        <Button
          onClick={this.onAccountSelectorButtonClick.bind(this)}
          className={`${this.props.classes.customToolbarItem} account-selector-button`}
        >
          <span className="text">
            {this.props.description}
          </span>
          <span className="caret" />
        </Button>
      </MultipleAccountSelectorPopover>
    );
  }
}

AccountSelector.propTypes = {
  scope: PropTypes.shape({
    values: PropTypes.shape({
      aid: PropTypes.number,
    }),
  }).isRequired,
  serverContext: PropTypes.shape({
    ServicesEndpoints: PropTypes.object.isRequired,
    Permissions: PropTypes.object.isRequired,
    Token: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  updateSelected: PropTypes.func.isRequired,
  getSelectedScope: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
};
